<template>
  <div class="app mx-lg-auto ml-3 mr-3 mt-3 mb-3">

    <div class="row app__head">

      <v-dialog max-width="300" max-height="400" v-model="menu2">
        <template v-slot:activator="{ props }">
          <v-btn class="btn btn--small" icon="mdi-earth" v-bind="props" variant="text" color="#6a6a6b"></v-btn>
        </template>

        <template v-slot:default="{ isActive }">
          <v-card title="Nazioni">
            <v-card-text>
              <!-- Aggiungi campo di ricerca -->
              <v-text-field v-model="countrySearch" label="Cerca nazione" prepend-inner-icon="mdi-magnify" clearable
                class="mb-4" variant="underlined"></v-text-field>

              <v-list v-if="countriesLoading">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
              </v-list>

              <v-list v-else-if="filteredCountries.length > 0">
                <v-list class="mt-0">
                  <v-list-item prepend-avatar="https://flagcdn.com/w40/it.png" title="Italia"
                    @click="selectCountry('it')">
                  </v-list-item>
                </v-list>
                <v-divider :thickness="3" class="mb-2"></v-divider>

                <v-list-item v-for="country in filteredCountries" :key="country.code"
                  :prepend-avatar="`https://flagcdn.com/w40/${country.code}.png`" :title="country.name"
                  @click="selectCountry(country.code)">
                  <template v-slot:append>
                    <v-icon v-if="selectedCountry === country.code" color="primary">mdi-check</v-icon>
                  </template>
                </v-list-item>
              </v-list>

              <div v-if="!countriesLoading && filteredCountries.length === 0" class="text-center py-4">
                Nessun risultato trovato
              </div>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text="Chiudi" @click="isActive.value = false"></v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>

      <v-dialog max-width="300" max-height="400" v-model="menu3">
        <template v-slot:activator="{ props }">
          <v-btn class="btn btn--small" icon="mdi-heart" v-bind="props" variant="text"
            :color="favorites.length > 0 ? 'red-darken-2' : '#6a6a6b'"></v-btn>
        </template>

        <template v-slot:default="{ isActive }">
          <v-card title="Preferiti">
            <v-card-text>
              <v-list v-if="favorites.length > 0">
                <v-list-item v-for="(station, index) in favorites" :key="index" @click="playFavorite(station)">
                  <template v-slot:prepend>
                    <v-avatar>
                      <v-img :src="station.favicon || defaultCover"></v-img>
                    </v-avatar>
                  </template>

                  <v-list-item-title>{{ station.name }}</v-list-item-title>
                  <v-list-item-subtitle>{{ station.country }}</v-list-item-subtitle>

                  <template v-slot:append>
                    <v-btn icon color="red" @click.stop="removeFavorite(station)" variant="text">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                </v-list-item>
              </v-list>
              <div v-else class="pa-4 text-center loading">Nessun preferito</div>
            </v-card-text>

            <v-card-actions>
              <!-- Pulsante Elimina Tutti (mostrato solo se ci sono preferiti) -->
              <v-btn v-if="favorites.length > 0" color="red" variant="text" @click="confirmClearAll"
                prepend-icon="mdi-delete-empty">
                Elimina tutti
              </v-btn>

              <v-spacer></v-spacer>

              <v-btn text="Chiudi" @click="isActive.value = false"></v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>

      <v-dialog max-width="300" max-height="400" v-model="menu">
        <template v-slot:activator="{ props }">
          <button class="btn btn--small playlist" v-bind="props"></button>
        </template>

        <template v-slot:default="{ isActive }">
          <v-card title="Stazioni Radio">
            <v-card-text>
              <!-- Aggiungi campo di ricerca -->
              <v-text-field v-model="stationSearch" label="Cerca stazione" prepend-inner-icon="mdi-magnify" clearable
                class="mb-4" @input="filterStations" @click:clear="this.resetStationSearch()"
                variant="underlined"></v-text-field>

              <v-list v-if="filteredStationsList.length > 0">
                <v-list-item v-for="(station, filteredIndex) in filteredStationsList" :key="station.stationuuid"
                  @click="switchStationFromFiltered(filteredIndex)"
                  :class="{ 'active-station': currentStation.stationuuid === station.stationuuid }">
                  <template v-slot:prepend>
                    <v-avatar>
                      <v-img :src="station.favicon || defaultCover"></v-img>
                    </v-avatar>
                  </template>

                  <v-list-item-title>{{ station.name }}</v-list-item-title>
                  <v-list-item-subtitle>
                    {{ station.country }} • {{ station.bitrate }}kbps
                  </v-list-item-subtitle>

                  <template v-slot:append>
                    <v-btn :class="station.favorite ? 'text-red' : ''" icon="mdi-heart" variant="text"
                      @click.stop="toggleFavorite(station)">
                    </v-btn>
                  </template>
                </v-list-item>
              </v-list>

              <div v-if="filteredStationsList.length === 0" class="pa-4 text-center">
                Nessuna stazione trovata
              </div>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text="Chiudi" @click="isActive.value = false"></v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>

    </div>

    <div v-if="isLoading" class="loading">
      Caricamento stazioni radio...
    </div>

    <div v-else-if="stations.length === 0" class="error">
      Nessuna stazione trovata
    </div>

    <div v-else>
      <div class="row app__body">
        <div class="flex-1-1-100">
          <v-img :width="300" aspect-ratio="16/9" cover src="https://www.gabriarcu.it/logo.png" class="mb-3"></v-img>

        </div>
        <div class="album">
          <div class="album__img" :style="{ backgroundImage: `url(${getImage(currentStation.favicon)})` }"></div>
          <div class="album__info">
            <h3 class="album__info-name">{{ currentStation?.name || 'Sconosciuto' }}</h3>
            <div class="progress flex-1-1-100">
              <img src="img/wave.gif" alt="" style="width: 50%; height: 50%; max-width: 300;" v-if="isTimerPlaying">
            </div>
            <p class="album__info-track flex-1-1-100">
              <span v-if="nowPlayingTitle" class="now-playing marquee">
                <span class="marquee-content">{{ nowPlayingTitle }}</span>
              </span>
              <span v-else>
                {{ stationSubtitle }}
              </span>
            </p>
          </div>
        </div>

      </div>
      <div class="row app__footer">
        <button class="btn prev btn--big" @click="prevStation"></button>
        <button class="btn play btn--big" @click="play" :class="{ pause: isTimerPlaying }"></button>
        <button class="btn next btn--big" @click="nextStation"></button>

      </div>

    </div>

  </div>
  <p class="text-overline orange-lighten-3">{{ new Date().getFullYear() }} — <strong>RadioWebRadio</strong> -
    Gabriarcu</p>
</template>

<script>
import Hls from 'hls.js';
import { nowPlaying } from './metadata.js';
import { startTitleRotation, stopTitleRotation } from '@/utils/updateTitle';

export default {
  name: 'HomeView',
  data() {
    return {
      audio: null,
      hls: null,
      isTimerPlaying: false,
      isLoading: true,
      countriesLoading: true,
      stations: [], // Array completo delle stazioni
      stationsList: [], // Array per la visualizzazione nel menu
      countries: [],
      selectedCountry: 'it',
      currentStation: null,
      currentStationIndex: 0,
      defaultCover: 'https://media.istockphoto.com/id/506176142/photo/vintage-radio.jpg?s=612x612&w=0&k=20&c=n-0-n5h72nyj8zbCqCxRoSWfsCXct0Ski-mA9ZRa__c=',
      apiUrl: 'https://de2.api.radio-browser.info/json/stations/search',
      fav: true,
      menu: false,
      message: false,
      hints: true,
      menu2: false,
      menu3: false,
      message2: false,
      hints2: true,
      favorites: JSON.parse(localStorage.getItem('favoriteStations')) || [],
      nowPlayingTitle: null,
      metadataSubscription: null,
      metadataInterval: null,
      countrySearch: '',
      stationSearch: '',
      filteredStationsList: [],
    };
  },
  watch: {
    currentStation(newStation) {
      if (newStation) {
        startTitleRotation(newStation.name, this.nowPlayingTitle);
      } else {
        stopTitleRotation();
        document.title = 'Radio Player';
      }
    },
    nowPlayingTitle(newTitle) {
      if (this.currentStation) {
        startTitleRotation(this.currentStation.name, newTitle);
      }
    },
    stationsList(newVal) {
      this.filteredStationsList = [...newVal];
    }
  },
  computed: {
    stationSubtitle() {
      if (!this.currentStation) return '';
      return [
        this.currentStation.tags,
        this.currentStation.country,
        this.currentStation.bitrate ? `${this.currentStation.bitrate}kbps` : ''
      ].filter(Boolean).join(' • ');
    },
    filteredCountries() {
      if (!this.countrySearch) {
        return this.countries;
      }
      const searchTerm = this.countrySearch.toLowerCase();
      return this.countries.filter(country =>
        country.name.toLowerCase().includes(searchTerm) ||
        country.code.toLowerCase().includes(searchTerm)
      );
    },

  },
  methods: {
    filterStations() {
      if (!this.stationSearch) {
        this.filteredStationsList = [...this.stationsList];
        return;
      }
      const searchTerm = this.stationSearch.toLowerCase();
      this.filteredStationsList = this.stationsList.filter(station =>
        station.name.toLowerCase().includes(searchTerm) ||
        (station.country && station.country.toLowerCase().includes(searchTerm)) ||
        (station.tags && station.tags.toLowerCase().includes(searchTerm))
      );
    },
    startMetadataTracking() {
      this.stopMetadataTracking(); // Pulisci eventuali tracker precedenti
      if (!this.currentStation?.url_resolved) return;

      // Inizia il tracking
      this.metadataSubscription = nowPlaying.subscribe(({ title, error }) => {
        if (error) {
          console.error('Metadata error:', error);
          return;
        }

        // Estrai e formatta titolo e artista
        this.nowPlayingTitle = this.formatMetadata(title);

        // Aggiorna il titolo della pagina con i nuovi metadati
        const metadata = this.formatMetadata(title); // Formatta i metadati
        startTitleRotation(this.currentStation.name, metadata || '');
      });

      // Aggiorna ogni 5 secondi
      this.metadataInterval = setInterval(() => {
        nowPlaying.trackStream(this.currentStation.url_resolved);
      }, 5000);

      // Prima chiamata immediata
      nowPlaying.trackStream(this.currentStation.url_resolved);
    },

    stopMetadataTracking() {
      if (this.metadataSubscription) {
        this.metadataSubscription.unsubscribe();
        this.metadataSubscription = null;
      }
      if (this.metadataInterval) {
        clearInterval(this.metadataInterval);
        this.metadataInterval = null;
      }
      this.nowPlayingTitle = null;
    },

    // Modifica questi metodi esistenti
    startPlayback() {
      if (!this.currentStation) return;

      if (this.hls) {
        this.hls.destroy();
      }

      const url = this.currentStation.url_resolved;

      if (url.includes('m3u8')) {
        this.hls = new Hls();
        this.hls.loadSource(url);
        this.hls.attachMedia(this.audio);
        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          this.audio.play();
          this.startMetadataTracking(); // Avvia il tracking quando la riproduzione inizia
        });
      } else {
        this.audio.src = url;
        this.audio.play();
        this.startMetadataTracking(); // Avvia il tracking quando la riproduzione inizia
      }
    },

    stopPlayback() {
      this.audio.pause();
      if (this.hls) {
        this.hls.destroy();
      }
      this.stopMetadataTracking(); // Ferma il tracking quando la riproduzione si ferma

      // Reimposta il titolo della pagina
      startTitleRotation(this.currentStation?.name || 'Radio Player', '');
    },

    switchStation(filteredIndex) {
      if (this.filteredStationsList.length === 0) return;

      // Usa direttamente l'indice filtrato
      const station = this.filteredStationsList[filteredIndex];
      this.currentStation = station;

      // Trova l'indice originale per mantenere la compatibilità
      this.currentStationIndex = this.stations.findIndex(s => s.stationuuid === station.stationuuid);

      this.stopMetadataTracking();

      if (this.isTimerPlaying) {
        this.stopPlayback();
        this.startPlayback();
      } else {
        this.play();
      }
      this.menu = false;
    },

    prevStation() {
      let newIndex = this.currentStationIndex - 1;
      if (newIndex < 0) newIndex = this.stations.length - 1;
      this.switchStationByIndex(newIndex);
    },

    nextStation() {
      let newIndex = this.currentStationIndex + 1;
      if (newIndex >= this.stations.length) newIndex = 0;
      this.switchStationByIndex(newIndex);
    },
    switchStationByIndex(index) {
      this.currentStationIndex = index;
      this.currentStation = this.stations[index];
      this.stopMetadataTracking();

      if (this.isTimerPlaying) {
        this.stopPlayback();
        this.startPlayback();
      }
    },
    switchStationFromFiltered(filteredIndex) {
      const filteredStation = this.filteredStationsList[filteredIndex];
      const originalIndex = this.stations.findIndex(
        s => s.stationuuid === filteredStation.stationuuid
      );

      if (originalIndex !== -1) {
        this.switchStationByIndex(originalIndex);
      }
      this.menu = false;
    },
    switchStationOriginal(originalIndex) {
      this.currentStationIndex = originalIndex;
      this.currentStation = this.stations[originalIndex];
      this.stopMetadataTracking();

      if (this.isTimerPlaying) {
        this.stopPlayback();
        this.startPlayback();
      } else {
        this.play();
      }
    },
    async fetchCountryCodes() {
      try {
        const response = await fetch('https://flagcdn.com/it/codes.json');
        const data = await response.json();
        this.countries = Object.entries(data)
          .map(([code, name]) => ({ code: code.toLowerCase(), name }))
          .sort((a, b) => a.name.localeCompare(b.name));
      } catch (error) {
        console.error('Error fetching countries:', error);
      } finally {
        this.countriesLoading = false;
      }
    },

    async fetchStations(countryCode = 'IT') {
      try {
        this.isLoading = true;
        const params = new URLSearchParams({
          countrycode: countryCode,
          hidebroken: 'true',
          reverse: 'true',
          order: 'clickcount',
          limit: '300',
        });

        const response = await fetch(`${this.apiUrl}?${params}`);
        if (!response.ok) throw new Error('Network response was not ok');

        let stations = await response.json();

        // Filtra solo le stazioni con URL HTTPS
        this.stations = stations.filter(station => {
          if (!station.url_resolved) return false;

          // Controlla se l'URL inizia con https:// O contiene icecast
          return station.url_resolved.startsWith('https://') ||
            station.url_resolved.toLowerCase().includes('icecast')
            || station.url_resolved.toLowerCase().endsWith('.mp3');
        });
        // this.stations = await response.json();
        this.stationsList = [...this.stations];
        if (this.stations.length > 0) {
          this.currentStation = this.stations[0];
          this.preloadFavicons();
        } else {
          console.warn("Nessuna stazione HTTPS trovata");
          this.stations = [];
          this.stationsList = [];
        }
      } catch (error) {
        console.error('Error fetching stations:', error);
        this.stations = [];
        this.stationsList = [];
      } finally {
        this.isLoading = false;
      }
    },
    preloadFavicons() {
      this.stations.forEach(station => {
        if (station.favicon) {
          const link = document.createElement('link');
          link.rel = "prefetch";
          link.href = station.favicon;
          link.as = "image";
          document.head.appendChild(link);
        }
      });
    },

    selectCountry(code) {
      this.selectedCountry = code;
      this.fetchStations(code.toUpperCase());
      this.menu2 = false;
    },

    play() {
      if (!this.audio.paused) {
        this.stopPlayback();
        this.isTimerPlaying = false;
      } else {
        this.startPlayback();
        this.isTimerPlaying = true;
      }

      // Aggiorna il titolo della pagina con il nome della stazione corrente
      startTitleRotation(this.currentStation?.name || 'Radio Player', this.nowPlayingTitle || '');
    },


    toggleFavorite(station) {
      const index = this.favorites.findIndex(f => f.stationuuid === station.stationuuid);

      if (index === -1) {
        // Aggiungi ai preferiti
        station.favorite = true;
        this.favorites.push({
          stationuuid: station.stationuuid,
          name: station.name,
          url_resolved: station.url_resolved,
          favicon: station.favicon,
          country: station.country
        });
      } else {
        // Rimuovi dai preferiti
        station.favorite = false;
        this.favorites.splice(index, 1);
      }

      // Salva in localStorage
      localStorage.setItem('favoriteStations', JSON.stringify(this.favorites));
    },

    playFavorite(station) {
      const index = this.stations.findIndex(s => s.stationuuid === station.stationuuid);
      if (index !== -1) {
        this.currentStationIndex = index;
        this.currentStation = this.stations[index];
        if (!this.isTimerPlaying) {
          this.play();
        } else {
          this.stopPlayback();
          this.startPlayback();
        }
      }
      this.menu3 = false;
    },

    getImage(favicon) {
      return favicon || 'https://media.istockphoto.com/id/506176142/photo/vintage-radio.jpg?s=612x612&w=0&k=20&c=n-0-n5h72nyj8zbCqCxRoSWfsCXct0Ski-mA9ZRa__c=';
    },
    formatMetadata(rawTitle) {
      if (!rawTitle) {
        stopTitleRotation(); // Chiama direttamente la funzione importata
        return null;
      }

      const parts = rawTitle.split('~');
      const title = parts[0]?.trim();
      const artist = parts[1]?.trim();
      const year = parts[3]?.trim();

      // Restituisci una stringa combinata
      return [title, artist, year && `(${year})`].filter(Boolean).join(' - ');
    },
    resetStationSearch() {
      this.stationSearch = ''; // Resetta la ricerca
      this.filteredStationsList = [...this.stationsList]; // Mostra tutte le stazioni
    },
    removeFavorite(station) {
      // Trova l'indice della stazione nei preferiti
      const index = this.favorites.findIndex(fav => fav.stationuuid === station.stationuuid);

      if (index !== -1) {
        // Rimuovi dai preferiti
        this.favorites.splice(index, 1);

        // Aggiorna anche la stazione nella lista principale
        const mainIndex = this.stations.findIndex(s => s.stationuuid === station.stationuuid);
        if (mainIndex !== -1) {
          this.stations[mainIndex].favorite = false;
        }

        // Aggiorna localStorage
        localStorage.setItem('favoriteStations', JSON.stringify(this.favorites));
      }
    },
    confirmClearAll() {
      if (confirm('Sei sicuro di voler eliminare tutti i preferiti?')) {
        this.clearAllFavorites();
      }
    },

    clearAllFavorites() {
      // Rimuovi lo stato di preferito da tutte le stazioni
      this.stations.forEach(station => {
        station.favorite = false;
      });

      // Svuota l'array dei preferiti
      this.favorites = [];

      // Aggiorna il localStorage
      localStorage.setItem('favoriteStations', JSON.stringify(this.favorites));
    },
  },
  async created() {
    this.audio = new Audio();
    await this.fetchCountryCodes();
    await this.fetchStations();
    this.stations.forEach(station => {
      station.favorite = this.favorites.some(f => f.stationuuid === station.stationuuid);
    });
  },
  mounted() {
    // Inizializza la lista filtrata
    this.filteredStationsList = [...this.stationsList];
  },
  beforeUnmount() {
    this.stopPlayback();
    this.stopTitleRotation() // Chiama direttamente la funzione importata
    this.stopMetadataTracking(); // Pulisci alla distruzione del componente


  }
}
</script>

<style>
/* Tutti gli stili rimangono invariati */
*,
*::before,
*::after {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

body {
  font-size: 28px;
  background-color: #d5dbdb;
}

.text-red .v-icon {
  color: #ff0000 !important;
}

.v-list-item.active-station {
  background: rgba(255, 255, 255, 0.1);
  border-left: 4px solid #E8550C;
}

.now-playing {
  display: block;
  font-weight: 500;
  margin-bottom: 4px;
}

.loading,
.error {
  text-align: center;
  color: #A7A8AA;
  padding: 2rem;
  font-size: 1.2rem;
}

.album__info-track {
  font-size: 16px;
  color: #6a6a6a;
  margin-top: 8px;
  line-height: 1.4;

  overflow: hidden;
  white-space: nowrap;
  width: 100%;

  padding-top: 5px;
  font-size: 16px;

}

.marquee {
  display: inline-block;
  overflow: hidden;
  width: 100%;
}

.marquee-content {
  display: inline-block;
  animation: marquee 15s linear infinite;
  padding-left: 100%;
  /* Inizia fuori dallo schermo */
}

@keyframes marquee {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-100%);
  }
}

/* Pausa l'animazione quando hover */
.marquee:hover .marquee-content {
  animation-play-state: paused;
}

.btn {
  cursor: pointer;
  position: relative;
  display: inline-block;
  outline: none;
  border-radius: 50px;
  background-color: #050606;
  background-image: linear-gradient(120deg, #47494B 0%, #18191D 100%);
  color: #84878A;
  text-align: center;
  border-style: solid;
  border-color: #2f3139;
  font-family: "Font Awesome 5 Free";
  font-weight: 600;
  text-align: center;
}

.btn::before {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
}

.btn--big {
  font-size: 1.1rem;
  height: 80px;
  width: 80px;
  border-width: 3px;
  line-height: 1;
  box-shadow: -3px -3px 20px #5b5b5b, 5px 5px 20px #050606;
}

.btn--big:active,
.btn--big.active {
  box-shadow: inset 10px 10px 20px rgba(209, 19, 2, 0.5), -3px -3px 20px #5b5b5b, 5px 5px 20px #050606;
}

.btn--small {
  box-shadow: -3px -3px 15px #6a6a6a, 3px 3px 15px #050606;
  font-size: 0.6rem;
  height: 50px;
  width: 50px;
  border-width: 2px;
  line-height: 1;
}

.btn--small:active,
.btn--small.active {
  box-shadow: inset 10px 10px 20px rgba(209, 19, 2, 0.5), -3px -3px 15px #6a6a6a, 3px 3px 15px #050606;
}

.btn:active,
.btn.active {
  border-color: #E8550C;
  background-image: linear-gradient(120deg, #E8550C 0%, #f47333 100%);
  color: #fff;
}

.btn.play {
  margin: 0 20px;
}

.btn.play::before {
  content: "";
  left: 50%;
}

.btn.play.pause {
  border-color: #E8550C;
  background-image: linear-gradient(120deg, #E8550C 0%, #f47333 100%);
  color: #fff;
  box-shadow: inset 10px 10px 20px rgba(209, 19, 2, 0.5), -3px -3px 20px #5b5b5b, 5px 5px 20px #050606;
}

.btn.play.pause::before {
  content: "";
  left: 50%;
}

.btn.pause::before {
  content: "";
  left: 50%;
}

.btn.dots::before {
  content: "";
  left: 50%;
}

.btn.playlist::before {
  content: "";
  left: 50%;
}

.btn.heart::before {
  content: "";
  left: 49%;
}

.btn.prev::before {
  content: "";
  left: 48%;
}

.btn.next::before {
  content: "";
  left: 50%;
}

.btn.back::before {
  content: "";
  left: 48%;
}

.app {
  padding: 35px;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-image: linear-gradient(#343A3F 0%, #232528 100%);
  border: 1px solid #393b3c;
  border-radius: 50px;
  box-shadow: 5px 5px 35px #18191D;
}

.app__head {
  justify-content: space-between;
}

.app__body {
  margin: 30px 0 50px;
  flex-direction: column;
}

.app__footer {
  justify-content: center;
  margin-bottom: 20px;
}

.row {
  display: flex;
  width: 100%;
}

.album {
  /* align-self: center; */
  align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 0px;
}

.album__img {
  border: 10px solid #18191D;
  height: 200px;
  width: 200px;
  border-radius: 100%;
  box-shadow: -5px -5px 25px #444444, 5px 5px 25px #050606;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.album__info {
  margin-top: 50px;
  text-align: center;
  color: #A7A8AA;
}

.album__info-name {
  font-size: 20px;
  /* padding-bottom: 10px; */
}

.progress {
  position: relative;
  margin-bottom: 0px;
}
</style>